import { render } from "./Header.vue?vue&type=template&id=595a283e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=595a283e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-595a283e"

export default script